<template>
    <div class="cc-free-delivery" v-if="freeDelivery.condition">
        <div class="cc-free-delivery__header" v-if="freeDelivery.remaining > 0">
            <div class="cc-free-delivery__title">{{ translations['Buy for at least'] }} <span class="cc-free-delivery__title__condition">{{ displayRemaining }}</span> {{ translations['and you get'] }} <span class="cc-free-delivery__title__benefit">{{ translations['free delivery'] }}!</span></div>
        </div>
        <div class="cc-free-delivery__header" v-if="freeDelivery.remaining === 0">
            <div class="cc-free-delivery__title"><span class="cc-free-delivery__title__benefit">{{ translations['You have got free shipping!'] }}!</span></div>
        </div>
        <div class="cc-free-delivery__main">
            <div class="cc-progressbar">
                <div class="cc-progressbar__progress" :style="{width: calculatePercent}"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                freeDelivery: state => state.freeDelivery,
            }),
            displayRemaining: function () {
                return this.freeDelivery.remaining ? this.freeDelivery.formatted.remaining : `...`;
            },
            calculatePercent: function () {
                return this.freeDelivery.percent ? this.freeDelivery.formatted.percent : `0%`;
            },
        },
        name: 'FreeDelivery',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-free-delivery {
            display: block;
            width: 100%;
            max-width: 100%;
            text-align: right;
        }

        @include mobile {
            .cc-free-delivery {
                text-align: left;
            }
        }

        .cc-free-delivery__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-free-delivery__title {
            font-size: 16px;
            display: inline-block;
        }

        .cc-free-delivery__title__condition {
            font-weight: bold;
        }

        .cc-free-delivery__title__benefit {
            text-transform: uppercase;
            font-weight: bold;
            color: $blue;
        }

        .cc-free-delivery__main {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-progressbar {
            display: inline-block;
            width: 450px;
            max-width: 100%;
            height: 16px;
            margin-top: 1.5rem;
            border-width: 1px;
            border-style: solid;
            border-color: $border-color;
        }

        .cc-progressbar__progress {
            display: block;
            width: 0;
            max-width: 100%;
            height: 100%;
            transition: width 1s;
            background: $blue;
        }
    }
</style>
